import { getTypeKey, transformTypesToTaskType } from 'utils'
import type { JobClientData, JobRetailerData, JobsDetailData, RegionsDetailData, v5 } from '@contracts'
import type { HeaderData } from 'components/TaskMetadataHeader/TaskMetadataHeader.d'

export const headerMetaData = (singleJobData: v5.JobsDetailData | null, regionData?: RegionsDetailData | null) => {
  const getRegionDisplayValue = (region: RegionsDetailData) => {
    const regionName = region?.name || 'Unknown Region'
    const locale = region?.locale?.toUpperCase().replace('_', '-') || ''
    return `${regionName} | ${locale}`
  }

  return [
    {
      field: getTypeKey<JobsDetailData>('product_id'),
      title: 'Product ID',
      value: singleJobData?.config?.product?.product_id || '-',
    },
    {
      field: getTypeKey<JobsDetailData>('group_id'),
      title: 'Variant ID',
      value: (singleJobData?.config as any)?.variant?.variant_id || '-',
    },
    {
      field: getTypeKey<JobClientData>('client_name'),
      title: 'Client',
      value: `${singleJobData?.client?.client_name} | ${singleJobData?.config?.brand?.brand_name}`,
    },
    {
      field: getTypeKey<JobRetailerData>('name'),
      title: 'Retailer',
      value: singleJobData?.retailer_name || '-',
    },
    {
      field: getTypeKey<JobsDetailData>('type'),
      title: 'Task type',
      value: transformTypesToTaskType(singleJobData?.type!),
    },
    {
      field: getTypeKey<JobRetailerData>('region'),
      title: 'Region',
      value: getRegionDisplayValue(regionData!),
    },
  ] as HeaderData[]
}
